import $ from "jquery";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Http from "../Common/Http";

import SupplyChain from "./Sidebar/SupplyChain";

// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import Http from "../Common/Http";

// const Header = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [user, setUser] = useState({});
//   const [notification, setNotification] = useState({});

//   const fetchData = () => {
//     Http.get("/me").then((res) => {
//       setUser(res.data.data);
//     });
//   };

const Sidebar = () => {
  const [active, setActive] = useState(window.location.pathname);
  const [receiveData, setReceiveData] = useState([]);
  const location = useLocation();
  const [user, setUser] = useState({});
  const [badge, setBadge] = useState([]);

  // console.log("active", active);

  // const fetchData = () => {
  //   Http.get("/me").then((res) => {
  //     setUser(res.data.data);
  //   });
  // };

  const fetchData = () => {
    Http.get("/staff-type-check").then((res) => {
      setReceiveData(res.data);
    });
    Http.get("/me").then((res) => {
      setUser(res.data.data);
    });
    // Http.get("/module-counts").then((res) => {
    //       setBadge(res.data);
    //     });
  };

  const [badgeNotification, setBadgeNotification] = useState();

  const fetchNotification = async () => {
    try {
      const res = await Http.get("/get-notification");
      setBadgeNotification(res.data);
    } catch (error) {
      console.error("Error fetching notification:", error);
    }
  };

  // Fetch /module-counts periodically
  useEffect(() => {
    const fetchModuleCounts = () => {
      // Http.get("/module-counts")
      //   .then((res) => {
      //     setBadge(res.data);
      //   })
      //   .catch((error) => {
      //     console.error("Error fetching module counts:", error);
      //   });
    };

    fetchModuleCounts(); // Initial fetch

    const intervalId = setInterval(fetchModuleCounts, 20000); // Fetch every 10 seconds

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  useEffect(() => {
    fetchData();
    fetchNotification();

    // Set interval to call every 5 minutes (300,000 ms)
    const intervalId = setInterval(fetchNotification, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleSidebarClick = (path) => {
    setActive(path);
  };

  useEffect(() => {
    $(".show-sub + .nav-sub").slideDown();

    $(".with-sub").on("click", function (e) {
      e.preventDefault();
      // Collapse all other submenus before toggling the current one
      $(".nav-sub").not($(this).next()).slideUp();
      $(".with-sub").not($(this)).removeClass("show-sub");

      // Now toggle the clicked submenu
      $(this).next().slideToggle();
      $(this).toggleClass("show-sub");
    });
  }, [receiveData]);

  if (location.pathname === "/" || location.pathname === "/login") return null;

  return (
    <div>
      <div className="am-sideleft">
        <ul className="nav am-sideleft-tab">
          <li className="nav-item w-100">
            <a href="#mainMenu" className="nav-link tx-18">
              {" "}
              <i className="fa fa-user"></i> &nbsp; {user.name}{" "}
            </a>
            {/* <a href="#mainMenu" className="nav-link">
              <i className="icon ion-ios-menu-outline tx-24" />
              <i className="fa fa-bars text-12"></i>
              <p className="nav-link" > {user.name} </p>
            </a> */}
          </li>
          {/* <li className="nav-item">
            <a href="#emailMenu" className="nav-link">
              <i className="icon ion-ios-email-outline tx-24" />
            </a>
          </li>
          <li className="nav-item">
            <a href="#chatMenu" className="nav-link">
              <i className="icon ion-ios-chatboxes-outline tx-24" />
            </a>
          </li>
          <li className="nav-item">
            <a href="#settingMenu" className="nav-link">
              <i className="icon ion-ios-gear-outline tx-24" />
            </a>
          </li> */}
        </ul>
        <div className="tab-content">
          <div id="mainMenu" className="tab-pane active">
            {/* {sidebarComponent} */}
            <ul className="nav am-sideleft-menu">
              {/* {receiveData !== "ho" && ( */}

              <li className="nav-item">
                <Link
                  to="/dashboard"
                  className={`nav-link ${
                    active === "/dashboard" ? "active" : ""
                  }`}
                  onClick={() => handleSidebarClick("/dashboard")}
                >
                  <i className="fa fa-tachometer" aria-hidden="true"></i>
                  <span>Dashboard</span>
                </Link>
              </li>
              {/* )} */}

              {/* Basic Setup */}
              {/* {(receiveData === "admin" || receiveData === "hr") && (
                <BasicSetup onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* WorkPlace */}
              {/* {(receiveData === "admin" || receiveData === "hr") && (
                <Workplace onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* Staff Management */}
              {/* {(receiveData === "admin" ||
                receiveData === "hr" ||
                receiveData === "staff") && (
                <StaffManagement
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )} */}
              {/* Artisan Setup */}
              {/* {(receiveData === "admin" ||
                receiveData === "hr" ||
                receiveData === "supply_chain" ||
                receiveData === "gstore" ||
                // receiveData === "body" ||
                receiveData === "jigger" ||
                receiveData === "casting" ||
                receiveData === "finishing" ||
                receiveData === "bk" ||
                receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export" ||
                receiveData === "dstore" ||
                receiveData === "mould" ||
                receiveData === "pstore" ||
                receiveData === "planning" ||
                receiveData === "depot" ||
                receiveData === "sagger") && (
                <ArtisanSetup
                  onMenuClick={handleSidebarClick}
                  active={active}
                  badge={badge}
                />
              )} */}

              {/* Payroll */}
              {/* {(receiveData === "admin" || receiveData === "hr") && (
                <Payroll onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* Accounts */}
              {/* {(receiveData === "admin" || receiveData === "accounts") && (
                <Accounts onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* Supply Chain */}
              {(receiveData === "admin" || receiveData === "supply_chain") && (
                <SupplyChain
                  role={receiveData}
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )}
              {/* Production */}
              {/* {(receiveData === "admin" ||
                receiveData === "supply_chain" ||
                receiveData === "body" ||
                receiveData === "production" ||
                receiveData === "gstore" ||
                receiveData === "dstore" ||
                receiveData === "pstore" ||
                receiveData === "jigger" ||
                receiveData === "casting" ||
                receiveData === "finishing" ||
                receiveData === "bk" ||
                receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export" ||
                receiveData === "mould" ||
                receiveData === "sagger" ||
                // receiveData === "lab" ||
                receiveData === "depot") && (
                <Production
                  role={receiveData}
                  onMenuClick={handleSidebarClick}
                  active={active}
                  badge={badge}
                />
              )} */}
              {/* {(receiveData === "admin" ||
                receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export") && (
                <Repair
                  role={receiveData}
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )} */}
              {/* {(receiveData === "admin" ||
                receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export") && (
                <Defect
                  role={receiveData}
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )} */}
              {/* Assets */}
              {/* {(receiveData === "admin" || receiveData === "supply_chain") && (
                <Assets onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* Sales */}
              {/* {(receiveData === "admin" ||
                receiveData === "depot" ||
                receiveData === "supply_chain") && (
                <Sales
                  role={receiveData}
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )} */}
              {/* Secondary Sales */}
              {/* {receiveData === "admin" && (
                <SecondarySales
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )} */}
              {receiveData === "ho" && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/artisan-store-stock"
                      className={`nav-link ${
                        active === "/artisan-store-stock" ? "active" : ""
                      }`}
                      onClick={() => setActive("/artisan-store-stock")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>Store Stock</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/reports/all-department-stock"
                      className={`nav-link ${
                        active === "/reports/all-department-stock"
                          ? "active"
                          : ""
                      }`}
                      onClick={() => setActive("/reports/all-department-stock")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>All Department Stock</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/reports/ball-mill-charge"
                      className={`nav-link ${
                        active === "/reports/ball-mill-charge" ? "active" : ""
                      }`}
                      onClick={() => setActive("/reports/ball-mill-charge")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>Total Ball Mill Charge</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/reports/production-workorder-item"
                      className={`nav-link ${
                        active === "/reports/production-workorder-item"
                          ? "active"
                          : ""
                      }`}
                      onClick={() => setActive("/reports/production-workorder-item")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>Work Order Item Report</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/reports/planning-item"
                      className={`nav-link ${
                        active === "/reports/planning-item" ? "active" : ""
                      }`}
                      onClick={() => setActive("/reports/planning-item")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>Planning Item Report</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/user-usages-activity-log"
                      className={`nav-link ${
                        active === "/user-usages-activity-log" ? "active" : ""
                      }`}
                      onClick={() => setActive("/user-usages-activity-log")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>User Usage Activity Log</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/product-ledger-report"
                      className={`nav-link ${
                        active === "/product-ledger-report" ? "active" : ""
                      }`}
                      onClick={() => setActive("/product-ledger-report")}
                    >
                      <i className="fa fa-globe" aria-hidden="true"></i>
                      <span>Product Ledger Report</span>
                    </Link>
                  </li>
                </>
              )}
              {/* Reports */}
              {(receiveData === "admin" ||
                receiveData === "staff" ||
                receiveData === "planning" ||
                receiveData === "supply_chain" ||
                receiveData === "demo") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/production-work-order"
                      className={`nav-link ${
                        active === "/production-work-order" ? "active" : ""
                      }`}
                      onClick={() => setActive("/production-work-order")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Company Order</span>
                      {/* <span className="badge bg-danger ms-2">{badge.workOrders}</span> */}
                    </Link>
                  </li>
                </>
              )}
              {(receiveData == "local_procurement" ||
                receiveData == "foreign_procurement") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/vendors"
                      className={`nav-link ${
                        active === "/vendors" ? "active" : ""
                      }`}
                      onClick={() => setActive("/vendors")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Vendors</span>
                      {/* <span className="badge bg-danger ms-2">{badge.workOrders}</span> */}
                    </Link>
                  </li>
                </>
              )}
              {(receiveData === "planning" ||
                receiveData === "gstore" ||
                receiveData == "depot" ||
                receiveData == "lab" ||
                receiveData == "mechanical" ||
                receiveData == "electrical" ||
                receiveData == "sample") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/product"
                      className={`nav-link ${
                        active === "/product" ? "active" : ""
                      }`}
                      onClick={() => setActive("/product")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Product</span>
                      {/* <span className="badge bg-danger ms-2">{badge.workOrders}</span> */}
                    </Link>
                  </li>
                </>
              )}
              {(receiveData === "planning" || receiveData === "sample") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/company"
                      className={`nav-link ${
                        active === "/company" ? "active" : ""
                      }`}
                      onClick={() => setActive("/company")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Company</span>
                      {/* <span className="badge bg-danger ms-2">{badge.workOrders}</span> */}
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "sample" || receiveData === "planning") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/sample-list"
                      className={`nav-link ${
                        active === "/sample-list" ? "active" : ""
                      }`}
                      onClick={() => setActive("/sample-list")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Sample List</span>
                      {/* <span className="badge bg-danger ms-2">{badge.workOrders}</span> */}
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "planning" ||
                receiveData === "jigger" ||
                receiveData === "glazing" ||
                receiveData === "gk") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/view-planning-for-jigger"
                      className={`nav-link ${
                        active === "/view-planning-for-jigger" ? "active" : ""
                      }`}
                      onClick={() => setActive("/view-planning-for-jigger")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Short Planning</span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "admin" ||
                receiveData === "supply_chain" ||
                receiveData === "planning" ||
                receiveData === "casting" ||
                receiveData === "jigger" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "demo") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/planning"
                      className={`nav-link ${
                        active === "/planning" ? "active" : ""
                      }`}
                      onClick={() => setActive("/planning")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Planning</span>
                    </Link>
                  </li>
                </>
              )}
              {(receiveData === "admin" ||
                receiveData === "staff" ||
                receiveData === "planning" ||
                receiveData === "supply_chain" ||
                receiveData === "sample" ||
                receiveData === "demo") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/shape"
                      className={`nav-link ${
                        active === "/shape" ? "active" : ""
                      }`}
                      onClick={() => setActive("/shape")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Shapes</span>
                      {/* <span className="badge bg-danger ms-2">{badge.workOrders}</span> */}
                    </Link>
                  </li>
                </>
              )}
              {receiveData === "planning" && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/sets"
                      className={`nav-link ${
                        active === "/sets" ? "active" : ""
                      }`}
                      onClick={() => setActive("/sets")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Set</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/machine"
                      className={`nav-link ${
                        active === "/machine" ? "active" : ""
                      }`}
                      onClick={() => setActive("/machine")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Machine</span>
                    </Link>
                  </li>
                </>
              )}
              {/* Work Plan */}
              {(receiveData === "planning" || receiveData === "sample") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/planning-image-upload"
                      className={`nav-link ${
                        active === "/planning-image-upload" ? "active" : ""
                      }`}
                      onClick={() => setActive("/planning-image-upload")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Decoration Designs</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/gless-colour"
                      className={`nav-link ${
                        active === "/gless-colour" ? "active" : ""
                      }`}
                      onClick={() => setActive("/gless-colour")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Glaze Colours</span>
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link
                      to="/code"
                      className={`nav-link ${active === "/code" ? "active" : ""
                        }`}
                      onClick={() => setActive("/code")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Decoration Code</span>
                    </Link>
                  </li> */}
                </>
              )}

              {(receiveData === "admin" ||
                receiveData === "depot" ||
                receiveData === "supply_chain" ||
                receiveData === "gstore" ||
                receiveData === "local_procurement" ||
                receiveData === "foreign_procurement") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/store-purchase-requisition-art"
                      className={`nav-link ${
                        active === "/store-purchase-requisition-art"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        setActive("/store-purchase-requisition-art")
                      }
                    >
                      {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                      <i className="fa fa-briefcase"></i>

                      <span>SPR</span>
                      {receiveData === "admin" && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {badgeNotification?.PurchaseRequisitionArt}
                          </span>
                        </>
                      )}
                      {(receiveData === "supply_chain" ||
                        receiveData === "gstore") && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {badgeNotification?.approvedPurchaseRequisitionArt}
                          </span>
                        </>
                      )}
                      {receiveData === "local_procurement" && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {
                              badgeNotification?.requestedPurchaseRequisitionArtForLocal
                            }
                          </span>
                        </>
                      )}
                      {receiveData === "foreign_procurement" && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {
                              badgeNotification?.requestedPurchaseRequisitionArtForForeign
                            }
                          </span>
                        </>
                      )}
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/direct-purchase"
                      className={`nav-link ${
                        active === "/direct-purchase" ? "active" : ""
                      }`}
                      onClick={() => setActive("/direct-purchase")}
                    >
                      {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                      <i className="fa fa-briefcase"></i>
                      <span>Purchase Order</span>
                      <span className="badge bg-danger ms-2">
                        {badgeNotification?.DirectPurchase
                          ? badgeNotification?.DirectPurchase
                          : ""}
                      </span>
                    </Link>
                  </li>

                  {receiveData != "local_procurement" &&
                    receiveData != "foreign_procurement" && (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/grn"
                            className={`nav-link ${
                              active === "/grn" ? "active" : ""
                            }`}
                            onClick={() => setActive("/grn")}
                          >
                            {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                            <i className="fa fa-briefcase"></i>
                            <span>MRR with QC</span>
                          </Link>
                        </li>
                      </>
                    )}
                </>
              )}
              {(receiveData === "admin" ||
                receiveData === "depot" ||
                receiveData === "planning" ||
                receiveData === "gstore") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/direct-issue"
                      className={`nav-link ${
                        active === "/direct-issue"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        setActive("/direct-issue")
                      }
                    >
                      {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                      <i className="fa fa-briefcase"></i>
                      <span>Direct Issue</span>
                      {/* <span className="badge bg-danger ms-2">
                        {badgeNotification?.DirectPurchase
                          ? badgeNotification?.DirectPurchase
                          : ""}
                      </span> */}
                    </Link>
                  </li>
                </>
              )}
              {receiveData != "planning" &&
                receiveData != "ho" &&
                receiveData != "supply_chain" &&
                // receiveData != "lab" &&
                receiveData != "local_procurement" &&
                receiveData != "foreign_procurement" && (
                  <>
                    <li className="nav-item">
                      <Link
                        to="/requisition-production"
                        className={`nav-link ${
                          active === "/requisition-production" ? "active" : ""
                        }`}
                        onClick={() => setActive("/requisition-production")}
                      >
                        <i className="fa fa-briefcase"></i>
                        <span>Store Requisition</span>
                        <span className="badge bg-danger ms-2">
                          {/* {badge.store_requisitions} */}
                        </span>
                        <span className="badge bg-danger ms-2">
                          {badgeNotification?.requisitionArt
                            ? badgeNotification?.requisitionArt
                            : badgeNotification?.requisitionArtRecive}
                        </span>
                      </Link>
                    </li>
                  </>
                )}
              {(receiveData === "body" ||
                // receiveData === "glazing" ||
                // receiveData === "mould" ||
                receiveData === "sagger" ||
                receiveData === "dstore" ||
                receiveData === "pstore" ||
                receiveData === "depot" ||
                receiveData === "gstore") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/requisition-production-return"
                      className={`nav-link ${
                        active === "/requisition-production-return"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        setActive("/requisition-production-return")
                      }
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Store Requisition Return</span>
                      <span className="badge bg-danger ms-2">
                        {/* {badge.store_requisitions_return} */}
                      </span>
                      <span className="badge bg-danger ms-2">
                        {badgeNotification?.reqReturnedQty}
                      </span>
                    </Link>
                  </li>
                </>
              )}
              {(receiveData === "body" ||
                receiveData === "jigger" ||
                receiveData === "casting" ||
                receiveData === "mould" ||
                receiveData === "gk" ||
                receiveData === "bk" ||
                receiveData === "decoration_firing" ||
                receiveData === "sagger" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dstore" ||
                receiveData === "selection" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export" ||
                receiveData === "pstore" ||
                receiveData === "dfw" ||
                receiveData === "sample") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/department-requisition-jcg"
                      className={`nav-link ${
                        active === "/department-requisition-jcg" ? "active" : ""
                      }`}
                      onClick={() => setActive("/department-requisition-jcg")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Requisition Department</span>
                      <span className="badge bg-danger ms-2">
                        {badgeNotification?.requestedRequisitionArt}
                      </span>
                    </Link>
                  </li>
                </>
              )}

              {receiveData === "dfw" && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/transfer-to-c"
                      className={`nav-link ${
                        active === "/transfer-to-c" ? "active" : ""
                      }`}
                      onClick={() => setActive("/transfer-to-c")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Transfer to C Class</span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "admin" ||
                receiveData === "body" ||
                receiveData === "gstore" ||
                receiveData === "dstore" ||
                receiveData === "pstore" ||
                receiveData === "mould" ||
                receiveData === "sagger" ||
                receiveData === "depot") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/issue"
                      className={`nav-link ${
                        active === "/issue" ? "active" : ""
                      }`}
                      onClick={() => setActive("/issue")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>
                        {receiveData === "gstore" || receiveData === "depot"
                          ? "Issue"
                          : "Received RM"}
                      </span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "admin" || receiveData === "body") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/ball-mill-charge"
                      className={`nav-link ${
                        active === "/ball-mill-charge" ? "active" : ""
                      }`}
                      onClick={() => setActive("/ball-mill-charge")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Ball Charge</span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "admin" || receiveData === "body") && (
                // receiveData === "jigger" ||
                // receiveData === "casting" ||
                // receiveData === "mould" ||
                // receiveData === "sagger" ||
                // receiveData === "dstore" ||
                // receiveData === "pstore" ||
                // receiveData === "selection" ||
                // receiveData === "decoration_local" ||
                // receiveData === "decoration_export" ||
                // receiveData === "dfw" ||
                // receiveData === "packing_local" ||
                // receiveData === "packing_export"
                // receiveData === "gstore" ||
                <>
                  <li className="nav-item">
                    <Link
                      to="/production"
                      className={`nav-link ${
                        active === "/production" ? "active" : ""
                      }`}
                      onClick={() => setActive("/production")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Production</span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "admin" ||
                receiveData === "mould" ||
                receiveData === "sagger" ||
                receiveData === "pstore" ||
                receiveData === "dstore" ||
                receiveData === "body" ||
                receiveData === "jigger" ||
                receiveData === "casting" ||
                receiveData === "finishing" ||
                receiveData === "dstore" ||
                receiveData === "bk" ||
                receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "decoration_firing" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export" ||
                receiveData === "sample" ||
                receiveData === "demo") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/transfer-art"
                      className={`nav-link ${
                        active === "/transfer-art" ? "active" : ""
                      }`}
                      onClick={() => setActive("/transfer-art")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Department Transfer</span>
                      <span className="badge bg-danger ms-2">
                        {badgeNotification?.departmentTransfer}
                      </span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "body" ||
                receiveData === "jigger" ||
                receiveData === "casting" ||
                receiveData === "bk" ||
                // receiveData === "decoration_local" ||
                // receiveData === "decoration_export" ||
                receiveData === "finishing") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/return-art"
                      className={`nav-link ${
                        active === "/return-art" ? "active" : ""
                      }`}
                      onClick={() => setActive("/return-art")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Department Return</span>
                      <span className="badge bg-danger ms-2">
                        {badgeNotification?.productionReturnItem}
                      </span>
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "bk" ||
                receiveData === "glazing" ||
                receiveData === "gk") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/loss-art"
                      className={`nav-link ${
                        active === "/loss-art" ? "active" : ""
                      }`}
                      onClick={() => setActive("/loss-art")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Loss</span>
                      <span className="badge bg-danger ms-2">
                        {badge.returns}
                      </span>
                    </Link>
                  </li>
                </>
              )}
              {(receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/repair-art"
                      className={`nav-link ${
                        active === "/repair-art" ? "active" : ""
                      }`}
                      onClick={() => setActive("/repair-art")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Repair</span>
                      <span className="badge bg-danger ms-2">
                        {badgeNotification?.repair}
                      </span>
                    </Link>
                  </li>
                </>
              )}

              {/* {(receiveData === "admin" ||
                receiveData === "glazing" ||
                receiveData === "gk" ||
                receiveData === "selection" ||
                receiveData === "decoration_local" ||
                receiveData === "decoration_export" ||
                receiveData === "dfw" ||
                receiveData === "packing_local" ||
                receiveData === "packing_export") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/defect-art"
                      className={`nav-link ${
                        active === "/defect-art" ? "active" : ""
                      }`}
                      onClick={() => setActive("/defect-art")}
                    >
                      <i className="fa fa-briefcase"></i>
                      <span>Defect</span>
                    </Link>
                  </li>
                </>
              )} */}

              {(receiveData == "body" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/body-daily-production-report"
                    className={`nav-link ${
                      active === "/body-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/body-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Body Production Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "jigger" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/jigger-daily-production-report"
                    className={`nav-link ${
                      active === "/jigger-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/jigger-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Jigger Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "finishing" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/finishing-daily-production-report"
                    className={`nav-link ${
                      active === "/finishing-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/finishing-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Finishing Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "casting" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/casting-daily-production-report"
                    className={`nav-link ${
                      active === "/casting-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/casting-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Casting Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "bk" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/bkl-daily-production-report"
                    className={`nav-link ${
                      active === "/bkl-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/bkl-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>BK Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "glazing" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/glazing-daily-production-report"
                    className={`nav-link ${
                      active === "/glazing-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/glazing-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Glazing Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "gk" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/gk-daily-production-report"
                    className={`nav-link ${
                      active === "/gk-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/gk-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>GK Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "selection" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/selection-daily-production-report"
                    className={`nav-link ${
                      active === "/selection-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/selection-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Selection Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "decoration_local" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/decoration-local-daily-production-report"
                    className={`nav-link ${
                      active === "/decoration-local-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/decoration-local-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Decoration Local Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "decoration_export" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/decoration-export-daily-production-report"
                    className={`nav-link ${
                      active === "/decoration-export-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/decoration-export-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Decoration Export Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "dfw" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/dfw-daily-production-report"
                    className={`nav-link ${
                      active === "/dfw-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/dfw-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>DFW Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "decoration_firing" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/decoration-firing-daily-production-report"
                    className={`nav-link ${
                      active === "/decoration-firing-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/decoration-firing-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Decoration Firing Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "packing_local" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/packing-local-daily-production-report"
                    className={`nav-link ${
                      active === "/packing-local-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/packing-local-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Packing Local Production And Transfer Report</span>
                  </Link>
                </li>
              )}
              {(receiveData == "packing_export" || receiveData == "admin") && (
                <li className="nav-item">
                  <Link
                    to="/packing-export-daily-production-report"  
                    className={`nav-link ${
                      active === "/packing-export-daily-production-report" ? "active" : ""
                    }`}
                    onClick={() => setActive("/packing-export-daily-production-report")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-tachometer"></i>
                    <span>Packing Export Production And Transfer Report</span>
                  </Link>
                </li>
              )}























              {receiveData == "lab" && (
                <>
                
                <li className="nav-item">
                  <Link
                    to="/receipe"
                    className={`nav-link ${
                      active === "/receipe" ? "active" : ""
                    }`}
                    onClick={() => setActive("/receipe")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-flask"></i>
                    <span>Recipe</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/decoration-receipe"
                    className={`nav-link ${
                      active === "/decoration-receipe" ? "active" : ""
                    }`}
                    onClick={() => setActive("/decoration-receipe")}
                  >
                    {/* <i className="fa fa-recipe" aria-hidden="true"></i> */}
                    <i className="fa fa-flask"></i>
                    <span>Decoration Recipe</span>
                  </Link>
                </li>
                </>
              )}
              {receiveData != "hr" &&
                receiveData !== "demo" &&
                receiveData !== "ho" &&
                receiveData != "local_procurement" &&
                receiveData != "foreign_procurement" &&
                // receiveData !== "gstore" &&
                // receiveData !== "depot" && 
                (
                  <>
                    <li className="nav-item">
                      <Link
                        to="/production-and-transfer-report"
                        className={`nav-link ${
                          active === "/production-and-transfer-report"
                            ? "active"
                            : ""
                        }`}
                        onClick={() =>
                          setActive("/production-and-transfer-report")
                        }
                      >
                        <i className="fa fa-tachometer" aria-hidden="true"></i>
                        <span>Production and Transfer Report</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/reports"
                        className={`nav-link ${
                          active === "/reports" ? "active" : ""
                        }`}
                        onClick={() => setActive("/reports")}
                      >
                        <i className="fa fa-tachometer" aria-hidden="true"></i>
                        <span>Reports</span>
                      </Link>
                    </li>
                  </>
                )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
